export const disclaimerOne = {
	reverse: false,
	inverse: false,
	topLine: {
		text: '',
	},
	headline: 'Términos de Uso y Descargo de Responsabilidad de GRUPO-AG',
	subtitle: '___________________',
	buttonLabel: 'Volver',

	linkTo: '/',
	redir: null,
	imgStart: 'start',
	img: './assets/svg/Work.svg',
	start: 'true',
};